import { atom } from "jotai";
import { DataSchema } from "common";

export type Model = DataSchema.Model;

export const modelsAtom = atom<Model[]>([]);
